import script from "./removeClothBackground.vue?vue&type=script&setup=true&lang=js"
export * from "./removeClothBackground.vue?vue&type=script&setup=true&lang=js"

import "./removeClothBackground.vue?vue&type=style&index=0&id=0c32092b&lang=less"

const __exports__ = script;

export default __exports__